<template>
  <div id="container">
    <div id="output">
      <div class="containerT">
        <div class="logo_box">
          <a-form :model="form" autocomplete="off" layout="vertical">
            <h3>
              储能系统控制台登录
            </h3>
            <a-form-item label="用户名称：" name="username" :rules="[{ required: true, message: '请输入用户名!' }]">
              <a-input v-model:value="form.username" size="large" />
            </a-form-item>

            <a-form-item label="登录密码：" name="password" :rules="[{ required: true, message: '请输入密码!' }]">
              <a-input-password v-model:value="form.password" size="large" />
            </a-form-item>

            <!-- <a-form-item name="remember">
              <a-checkbox v-model:checked="form.remember"
                >Remember me</a-checkbox
              >
            </a-form-item> -->

            <a-form-item>
              <a-button type="primary" html-type="submit" @click="login" size="large"
                class="ant-btn-submit">登录</a-button>
            </a-form-item>
          </a-form>

          <div class="admintip"></div>
        </div>
      </div>
      <canvas width="1920" height="936" style="display: block"></canvas>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";
import "@/assets/login1.css";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import Api from "@/api";
export default {
  name: "LoginPage",
  components: {},
  props: {},
  setup() {
    const store = useStore();
    const router = useRouter();
    const form = reactive({
      username: "",
      password: "",
      remember: true,
    });

    const login = () => {
      Api.login("/login", form).then((res) => {
        console.log('123', res);
        if (res.code == 1) {
          store.dispatch("User/login", res.data);
          router.push({ path: "/" });
        } else {
          console.log("121321111211211312");
        }
      });
      return false;
    };
    return {
      login,
      form, //记得导出
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#container {
  background: url("@/assets/bg22.png");
  background-size: 100% 100%;
}

.ant-input {
  background-color: rgba(255, 255, 255, .06) !important;
  border-color: #193a77;
  color: #c3d9ff !important;
}

.ant-input-password {
  background-color: rgba(255, 255, 255, .06) !important;
  border-color: #193a77;
}

:deep(.ant-input-affix-wrapper > input.ant-input) {
  background: transparent !important;
  color: #c3d9ff !important;
}

:deep(.ant-input-password-icon) {
  color: #96bcfd !important;
}

:deep(.ant-form-vertical .ant-form-item-label > label) {
  color: #96bcfd !important;
}

.ant-btn-submit {
  width: 100%;
}
</style>
